// extracted by mini-css-extract-plugin
export default {"wrapper":"error-page_wrapper__BfAmG"};